<template>
  <div class="page" style="overflow: auto;">
    <navigator-menu :parentMsg="project_id"></navigator-menu>
    <el-card class="label-body">
      <div style="width:100%; font-weight: bold; font-size: 30px; text-align:center;">Attribute Label</div>
      <el-divider />
      <el-row :gutter="10" style="height: 80px;">
        <el-col :span="6" style="font-weight: bold; font-size: 20px;"><div>Please select the concept to which this Attribute belongs({{ conceptList.length }})</div></el-col>
        <el-col :span="18" style="font-weight: bold; font-size: 20px;">
          <el-tag
              v-for="(tag, index) in conceptList"
              :key=index
              :color=tag.background_color
              :style="{
                  color: tag.text_color,
                  borderColor: tag.background_color,
                  }"
              size="large"
              @click="chooseConcept(tag)"
          >
            {{ tag.text }}
          </el-tag>
        </el-col>
        <el-divider border-style="dashed" />
      </el-row>
      <!-- 下面是每个概念所具有的Attribute -->
      <el-row :gutter="10" style="height: 80px;">
        <el-col :span="6" style="font-weight: bold; font-size: 20px;"><div>“{{chosenTagName}}” has attribute</div></el-col>
        <el-col :span="18" style="font-weight: bold; font-size: 20px;">
          <el-tag
              v-for="(tag, index) in attributeList"
              :key=index
              size="large"
          >
            {{ tag.attribute_name }}
          </el-tag>
        </el-col>
        <el-divider border-style="dashed" />
      </el-row>

      <el-row :gutter="10" style="height: 80px;">
        <el-col :span="6" style="font-weight: bold; font-size: 20px;"><div>Preview</div></el-col>
        <el-col :span="6" style="font-weight: bold; font-size: 20px;">
          <el-tag
              size="large"
          >
            {{ newTag.attribute_name }}
          </el-tag>
        </el-col>
        <el-divider border-style="dashed" />
      </el-row>
      <el-row :gutter="10" style="height: 80px;">
        <el-col :span="6" style="font-weight: bold; font-size: 20px;"><div>Attribute Label's Name</div></el-col>
        <el-col :span="12"><el-input v-model="newTag.attribute_name" placeholder="Please enter attribute's name here"></el-input></el-col>
        <el-divider border-style="dashed" />
      </el-row>

      <el-button type="success" @click="addTag" style="margin-left:30%;">Create Attribute</el-button>
      <el-button type="success" @click="resetNewTag" style="margin-left:10%;">Reset</el-button>
    </el-card>
    <!-- <el-backtop class="wow bounceInRight"/> -->
  </div>
</template>

<script>
import NavigatorMenu from "./ProNavigation";
import axios from 'axios'
import WOW from "wow.js";
export default {
  name: "Label",
  components: {
    //   AdvSearch,
    //   NavigatorMenuMobile,
    NavigatorMenu,
    //   Edit,
    //   Swiper
  },
  data(){
    return{
      project_id: this.$route.params.project_id,
      chosenTagName: 'to be chosen', // 被选中的tagname
      conceptList: [],
      allAttributeList: [],
      attributeList: [
        {
          id:-1,
          attribute_name:'Current Concept does not has attribute',
        }
      ],
      newTag: {
        attribute_name:'',
        label: -1,
      },// tag的格式需要注意一下
      csrfToken:"",
      Search: require("@element-plus/icons/lib/Search"),
      searchStyle: 'font-size:23px; height: 10.5vh; width: 70vw; border-radius: 35px;overflow:hidden;',
    }
  },
  created() {
    var strcookie = document.cookie;//获取cookie字符串
    var arrcookie = strcookie.split("; ");//分割
    //遍历匹配
    for ( var i = 0; i < arrcookie.length; i++) {
      var arr = arrcookie[i].split("=");
      if (arr[0] == "csrftoken"){
        this.csrfToken = arr[1];
      }
    }
    // this.csrfToken = response.data.token;
    console.log('csrfToken:'+this.csrfToken)

    var url = window.location.href
    var begin = url.indexOf('/project/') + 9
    var end = url.indexOf('/premark')
    this.project_id = url.slice(begin, end)
    axios({
      method: 'get',
      url: '/api/api/projects/'+this.project_id+'/labels/',
      headers:{
        'X-CSRFToken': this.csrfToken,
      },
      params: {
        id: this.project_id,
      },
    }).then(response => {
      if(response.status == 200){
        this.conceptList = response.data
        this.getAllAttribute()
      }
    }).catch((error) => {
      this.$message('网络连接失败！')
    })
  },
  mounted() {

    // this.suggestions = this.loadAll();
    // var swiper = new Swiper(".swiper-container", {
    //   effect: "coverflow",
    //   grabCursor: true,
    //   centeredSlides: true,
    //   slidesPerView: "auto",
    //   coverflowEffect: {
    //     rotate: 0, //把旋转角度改为0度
    //     stretch: 0,
    //     depth: 100,
    //     modifier: 1,
    //     slideShadows: true,
    //   },
    //   loop: true,
    // });
    const wow = new WOW({
      boxClass: "wow", // animated element css class (default is wow)
      animateClass: "animated", // animation css class (default is animated)
      offset: 0, // distance to the element when triggering the animation (default is 0)
      mobile: true, // trigger animations on mobile devices (default is true)
      live: true, // act on asynchronously loaded content (default is true)
      callback: function (box) {
        // the callback is fired every time an animation is started
        // the argument that is passed in is the DOM node being animated
      },
      scrollContainer: null, // optional scroll container selector, otherwise use window,
      resetAnimation: true, // reset animation on end (default is true)
    });
    wow.init();
    // this.echartinit();
  },
  methods: {
    chooseConcept(tag){
      console.log(tag)
      console.log(tag.id)
      this.chosenTagName = tag.text
      this.newTag.label = tag.id
      axios({
        method: 'get',
        url: '/api/api/projects/'+this.project_id+'/attributeLabels/?label_ids=' + this.newTag.label,
        headers:{
          'X-CSRFToken': this.csrfToken,
        },
      }).then(response => {
        if(response.status == 200){
          console.log(response.data) // 获得当前标签的Attribute
          console.log(response.data.length)
          if (response.data.length > 0){
            this.attributeList = response.data
          }
          else{
            // 返回值是空，即该概念下没有Attribute

            this.attributeList = response.data
            this.attributeList.push({id:-1,attribute_name:"Current Concept does not has attribute"})
            console.log("Current Concept does not has attribute")
          }
        }
      }).catch((error) => {
        this.$message('网络连接失败！')
      })
    },
    resetConcept(tag_id){ // 用于添加完Attribute后更新概念
      axios({
        method: 'get',
        url: '/api/api/projects/'+this.project_id+'/attributeLabels/?label_ids=' + tag_id,
        headers:{
          'X-CSRFToken': this.csrfToken,
        },
      }).then(response => {
        if(response.status == 200){
          console.log(response.data) // 获得当前标签的Attribute
          console.log(response.data.length)
          if (response.data.length > 0){
            this.attributeList = response.data
          }
          else{
            // 返回值是空，即该概念下没有Attribute

            this.attributeList = response.data
            this.attributeList.push({id:-1,attribute_name:"Current Concept does not has attribute"})
            console.log("Current Concept does not has attribute")
          }
        }
      }).catch((error) => {
        this.$message('网络连接失败！')
      })
    },
    getAllAttribute(){
      axios({
        method: 'get',
        url: '/api/api/projects/'+this.project_id+'/attributeLabels/',
        headers:{
          'X-CSRFToken': this.csrfToken,
        },
      }).then(response => {
        if(response.status == 200){
          console.log(response.data) // 获得全部的Attribute
          this.allAttributeList = response.data
        }
      }).catch((error) => {
        this.$message('网络连接失败！')
      })
    },
    addTag(){
      axios({
        method: 'post',
        url: '/api/api/projects/'+this.project_id+'/attributeLabels/',
        headers:{
          'X-CSRFToken': this.csrfToken,
        },
        data: this.newTag
      }).then(response => {
        console.log('response:')
        console.log(response)
        console.log(this.newTag.label)
        this.resetConcept(this.newTag.label)
        this.resetNewTag()
      }).catch((error) => {
        this.$message('网络连接失败！')
      })

    },
    resetNewTag(){
      var newTag = {
        attribute_name:'',
        label: this.newTag.label,
      }
      this.newTag = newTag
    },
  }
}
</script>

<style>
.page {
  padding: 0;
  margin: -8px;
  height: 100%;
  width: 100%;
  position:fixed;
  background-image: url("../assets/images/weiminghu.jpeg");
  background-size:cover;
}
.label-body{
  /* margin-left: 300px; */
  left: 350px;
  top: 15vh;
  position: absolute;
  height: 110%;
  width: 75%;
  background-color: rgba(255, 255, 255, 0.7);
  /* border-color: blueviolet;
  background-color: rgba(255, 255, 255, 0.7);; */
}
.el-tag{
  margin-right: 15px;
  font-size: 15px;
  border-color: borderColor;
}
</style>